import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const ImpulseItem = lazy(() => lazyRetry(() => import('containers/ImpulseItem')))
const ImpulseItemRegister = lazy(() => lazyRetry(() => import('containers/ImpulseItem/register')))

const route = [
  {
    name: i18n.t('routes.impulseItem.index'),
    path: '/impulse-item',
    main: ImpulseItem,
    exact: true,
    permissions: ['ROLE_EDITAR_CADASTRO_ITEM_IMPULSO']
  },
  {
    name: i18n.t('routes.impulseItem.register'),
    path: '/impulse-item/register',
    main: ImpulseItemRegister,
    exact: true,
    permissions: ['ROLE_EDITAR_CADASTRO_ITEM_IMPULSO']
  },
  {
    name: i18n.t('routes.impulseItem.edit'),
    path: '/impulse-item/edit/:id',
    main: ImpulseItemRegister,
    exact: true,
    permissions: ['ROLE_EDITAR_CADASTRO_ITEM_IMPULSO']
  }
]

export default route
